<app-header></app-header>
<div class="image-container">
    <img src="assets/navimage.png" width="100%" alt="Your Image">
    <div class="image-text">
      <p>Gallery</p>
    </div>
</div>
<div class="bg-white" style="height: 5vh;"></div>


<!-- <div class="py-2 px-5">
    
    <mat-label class="ms-1">Year</mat-label>
    <div class="p-1 opt">
        <mat-select  class="mt-2" >
          <mat-option [value]="1" selected>2022</mat-option>
          <mat-option [value]="2">2023</mat-option>
        </mat-select>
      </div>
</div> -->
    
<div class="container-fluid">
    <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="mx-1">group</mat-icon>
        <!-- <mat-icon>emoji_objects</mat-icon> -->
        Cultural Activities
      </ng-template>
      <div class="gallery-container">
        <div class="gallery-item">
          <img src="../../../assets/Cultural/culAct1.jpg" alt="Image 1">
       
        </div>
        <div class="gallery-item">
          <img src="../../../assets/Cultural/culAct2.jpg" alt="Image 2">
          
        </div>
        <div class="gallery-item">
          <img src="../../../assets/Cultural/culAct3.jpg" alt="Image 3">
          
        </div>
        <div class="gallery-item">
            <img src="../../../assets/Cultural/culAct4.jpg" alt="Image 3">
          </div>
      </div>

      <!-- <div class="gallery-container">
        <div class="gallery-item">
          <img src="../../../assets/Cultural/IMG-20240119-WA0017.jpg" alt="Image 1">
       
        </div>
        <div class="gallery-item">
          <img src="../../../assets/Cultural/IMG-20240119-WA0018.jpg" alt="Image 2">
          
        </div>
        <div class="gallery-item">
          <img src="../../../assets/Cultural/IMG-20240119-WA0019.jpg" alt="Image 3">
          
        </div>
        <div class="gallery-item">
            <img src="../../../assets/Cultural/IMG-20240119-WA0020.jpg" alt="Image 3">
          </div>
      </div>
      

      <div class="gallery-container">
        <div class="gallery-item">
          <img src="../../../assets/Cultural/IMG-20240119-WA0021.jpg" alt="Image 1">
       
        </div>
        <div class="gallery-item">
          <img src="../../../assets/Cultural/IMG-20240119-WA0022.jpg" alt="Image 2">
          
        </div>
        <div class="gallery-item">
          <img src="../../../assets/Cultural/IMG-20240119-WA0023.jpg" alt="Image 3">
          
        </div>
        <div class="gallery-item">
            <img src="../../../assets/Cultural/IMG-20240119-WA0024.jpg" alt="Image 3">
          </div>
      </div> -->

    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon mx-1">sports_rugby</mat-icon>
        Sports
      </ng-template>
      <div class="gallery-container">
        <div class="gallery-item">
            <img src="../../../assets/Sports/sports1.jpg" alt="Image 1">
         
          </div>
          <div class="gallery-item">
            <img src="../../../assets/Sports/sports2.jpg" alt="Image 2">
            
          </div>
          <div class="gallery-item">
            <img src="../../../assets/Sports/sports3.jpg" alt="Image 3">
            
          </div>
          <div class="gallery-item">
              <img src="../../../assets/Sports/sports4.jpg" alt="Image 3">
            </div>
      </div>

      <!-- <div class="gallery-container">
        <div class="gallery-item">
            <img src="../../../assets/Sports/IMG-20240131-WA0032.jpg" alt="Image 1">
         
          </div>
          <div class="gallery-item">
            <img src="../../../assets/Sports/IMG-20240131-WA0033.jpg" alt="Image 2">
            
          </div>
          <div class="gallery-item">
            <img src="../../../assets/Sports/IMG-20240131-WA0034.jpg" alt="Image 3">
            
          </div>
          <div class="gallery-item">
              <img src="../../../assets/Sports/IMG-20240131-WA0035.jpg" alt="Image 3">
            </div>
      </div>

      <div class="gallery-container">
        <div class="gallery-item">
            <img src="../../../assets/Sports/IMG-20240131-WA0036.jpg" alt="Image 1">
         
          </div>
          <div class="gallery-item">
            <img src="../../../assets/Sports/IMG-20240131-WA0037.jpg" alt="Image 2">
            
          </div>
          <div class="gallery-item">
            <img src="../../../assets/Sports/IMG-20240131-WA0038.jpg" alt="Image 3">
          </div>
      </div> -->
    </mat-tab>
  
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon mx-1">celebrations</mat-icon>
        School Celebration
      </ng-template>
  
      <div class="gallery-container">
        <div class="gallery-item">
            <img src="../../../assets/celebration/celeb1.jpg" alt="Image 1">
         
          </div>
          <div class="gallery-item">
            <img src="../../../assets/celebration/celeb2.jpg" alt="Image 2">
            
          </div>
          <div class="gallery-item">
            <img src="../../../assets/celebration/celeb3.jpg" alt="Image 3">
            
          </div>
          <div class="gallery-item">
              <img src="../../../assets/celebration/celeb4.jpg" alt="Image 3">
            </div>
      </div>


      <!-- <div class="gallery-container">
        <div class="gallery-item">
            <img src="../../../assets/celebration/IMG-20240119-WA0004.jpg" alt="Image 1">
         
          </div>
          <div class="gallery-item">
            <img src="../../../assets/celebration/IMG-20240119-WA0005.jpg" alt="Image 2">
            
          </div>
          <div class="gallery-item">
            <img src="../../../assets/celebration/IMG-20240119-WA0006.jpg" alt="Image 3">
            
          </div>
          <div class="gallery-item">
              <img src="../../../assets/celebration/IMG-20240119-WA0007.jpg" alt="Image 3">
            </div>
      </div>
      <div class="gallery-container">
        <div class="gallery-item">
            <img src="../../../assets/celebration/IMG-20240119-WA0008.jpg" alt="Image 1">
         
          </div>
          <div class="gallery-item">
            <img src="../../../assets/celebration/IMG-20240119-WA0009.jpg" alt="Image 2">
            
          </div>
          <div class="gallery-item">
            <img src="../../../assets/celebration/IMG-20240119-WA0010.jpg" alt="Image 3">
            
          </div>
          <div class="gallery-item">
              <img src="../../../assets/celebration/IMG-20240119-WA0011.jpg" alt="Image 3">
            </div>
      </div> -->
    </mat-tab>
  </mat-tab-group>
</div>

  
<app-footer></app-footer>

  

  